import { render, staticRenderFns } from "./DashboardDictionaryUpload.vue?vue&type=template&id=2bcd6173&scoped=true"
import script from "./DashboardDictionaryUpload.vue?vue&type=script&lang=js"
export * from "./DashboardDictionaryUpload.vue?vue&type=script&lang=js"
import style0 from "./DashboardDictionaryUpload.vue?vue&type=style&index=0&id=2bcd6173&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd6173",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bcd6173')) {
      api.createRecord('2bcd6173', component.options)
    } else {
      api.reload('2bcd6173', component.options)
    }
    module.hot.accept("./DashboardDictionaryUpload.vue?vue&type=template&id=2bcd6173&scoped=true", function () {
      api.rerender('2bcd6173', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/DashboardDictionaryUpload.vue"
export default component.exports